export enum QueryParamKey {
    REDIRECT = 'redirect',
}

export interface QueryParams {
    [QueryParamKey.REDIRECT]?: string;
}
